<template>
  <div id="user-detail-warp">
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      aria-autocomplete="on"
      autocomplete="on"
    >
      <v-layout align-baseline wrap>
        <v-flex :class="grid">
          <p class="display-18 font-weight-medium text-align-center">
            <span class="primary--text">*</span>
            {{ cvPopup.email }}
          </p>
          <EmailField
            @clearEmailValidation="updatedEmailValidation = ''"
            :disabled="false"
            :current-mail="email"
            :editable="true"
            :new-to-check="true"
            @newEmail="handleEmailUpdate"
            @alertError="emailExists"
            @copy.prevent
            @cut.prevent
          />
          <v-alert
            v-if="emailError"
            type="error"
            dense
            class="py-0"
            color="primary"
          >
            {{ emailErrorText }}
          </v-alert>
        </v-flex>
        <v-flex>
          <p class="display-18 font-weight-medium text-align-center">
            <span class="primary--text">*</span>
            {{ cvPopup.emailValidation }}
          </p>
          <v-text-field
            v-model="updatedEmailValidation"
            outlined
            rounded
            solo
            :rules="emailValidationRules"
            type="text"
            label="הקלד שנית לצורך אימות"
            prepend-inner-icon="mdi-email-outline"
            ref="emailValidationField"
            required
            :disabled="!isEmailValid || emailExistsError"
            @paste.prevent
            autocomplete="new-email"
            dense
            dir="auto"
          />
        </v-flex>
        <v-flex :class="grid">
          <p class="display-18 font-weight-medium text-align-center">
            <span class="primary--text">*</span>
            {{ cvPopup.password }}
          </p>
          <PasswordField @newPassword="handlePasswordUpdate" />
          <v-alert
            v-if="passwordError"
            type="error"
            dense
            color="primary"
            class="py-0"
          >
            {{ passwordErrorText }}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout v-show="displaySave" justify-start pa-0 column>
        <v-flex xs12 pa-0 ma-0 text-right>
          <small class="red--text">*שדות חובה</small>
        </v-flex>
      </v-layout>
      <v-layout v-show="displaySave" justify-end pa-0>
        <v-flex xs12 pa-0 text-center>
          <DrBtn
            ref="showAll"
            :action="sendUpdatedDetails"
            type-btn="orange_btn_narrow show-all-selection"
            :loader="inProcess"
            :btn-enabled="!valid || emailExistsError"
          >
            {{ cvPopup.saveEdit }}
          </DrBtn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>


<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';

import EmailField from '@/components/Forms/Form_Fields/EmailField';
import PasswordField from '@/components/Forms/Form_Fields/PasswordField';

import CurrentUser from '@/components/mixins/CurrentUser';
import { UPDATE_EMAIL } from '@/lib/api.js';

export default {
  mixins: [CurrentUser],
  components: {
    EmailField,
    PasswordField,
  },

  props: {
    displaySave: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      grid: 'xl4 lg4 md4 sm12 xs12',
      errorsText: t('titles.errorMessages'),
      valid: false,
      lazy: false,
      phone: null,
      updatedEmail: '',
      updatedEmailValidation: '',
      password: null,
      updateErrorTxt: null,
      sendToSimilarJobs: null,
      inProcess: false,
      emailError: null,
      emailErrorText: null,
      passwordError: null,
      passwordErrorText: null,
      emailExistsError: false,
      emailValidationRules: [(v) => !!v && this.checkEmailValidation()],
    };
  },

  computed: {
    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(
        this.updatedEmail
      );
    },
    currUserDetails() {
      return this.CurrentUser;
    },
    email() {
      return this.currUserDetails ? this.currUserDetails.Email : '';
    },
  },

  watch: {
    isValid(val) {
      this.$emit('formValidated', val);
    },
  },
  mounted() {},

  methods: {
    checkEmailValidation() {
      if (this.updatedEmailValidation.localeCompare(this.updatedEmail)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    handleEmailUpdate(email) {
      this.updatedEmail = email;
    },
    handlePasswordUpdate(password) {
      this.password = password;
    },
    emailExists(bool) {
      this.emailExistsError = bool;
    },

    validate() {},
    showAlert(text) {
      this.$bus.$emit('showDialog', text);
      this.resetErrors();

      this.inProcess = false;
    },
    resetErrors() {
      this.passwordError = false;
      this.passwordErrorText = '';
      this.emailErrorText = '';
      this.emailError = false;
    },

    async sendUpdatedDetails() {
      this.resetErrors();
      this.inProcess = true;
      if (this.valid) {
        const data = {
          Email: this.updatedEmail,
          Password: this.password,
        };

        /**
         * emit @Boolean to spinner indicator gif in CVDetails Component
         */
        this.$nuxt.$emit('inProgress', true);

        return await this.$axios
          .post(`${UPDATE_EMAIL}`, data)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            this.fetchUserProfile();
            this.$nuxt.$emit('inProgress', false);
            this.inProcess = false;

            /**
             * only on personal pages edit
             */
            if (this.displaySave) {
              this.$nuxt.$emit('toggleEditForm');
            }


            this.$nuxt.$emit('openOTP', 'default');


            return {
              valid: true,
              error: null,
            };
          })
          .catch((e) => {
            const errorType = Object.keys(e)[0];

            switch (errorType) {
              case 'WrongPassword':
                this.passwordError = true;
                this.passwordErrorText = this.errorsText[errorType];
                break;
              case 'EmailsIsIdentical':
                this.emailError = true;
                this.emailErrorText = this.errorsText[errorType];
                break;
              default:
            }

            this.updateErrorTxt = this.errorsText[errorType];

            this.$nuxt.$emit('inProgress', false);
            this.inProcess = false;
            return {
              valid: true,
              error: e,
            };
          });
      } else {
        this.$emit('disableSendCV');
        return { valid: false, error: null };
      }
    },
    async fetchUserProfile() {
      await this.$auth.fetchUser();
    },
  },
};
</script>

<style lang="scss" scoped>
#user-detail-warp {
  margin: 0 auto;
}

#user-detail-warp .layout .flex {
  margin: 0;
  padding: 0 10px;
}

.flex p {
  text-align: right;
  margin: 0 10px 5px;
}

@media only screen and (min-width: 920px) {
  .flex p {
    display: block;
  }
}
</style>
